import { createUseStyles } from 'react-jss'
import { regularFont, textSize, borderColor, color, backgroundColor } from 'styles/helpers'
import checkboxSvg from 'styles/images/checkbox.svg'
import creditCardSvg from 'styles/images/credit-card.svg'
import selectArrowSvg from 'styles/images/select-arrow.svg'

const inputReset = theme => ({
  display: 'inline-block',
  borderRadius: 4,
  appearance: 'none',
  border: '1px solid',
  ...borderColor('textPlaceholder', theme.theme),
  ...backgroundColor('inputBackground', theme.theme),
  ...textSize(14, 19),
  ...regularFont(),
  ...color('textDefault', theme.theme),

  '&:hover': {
    ...borderColor('textDefault', theme.theme),
  },

  '&:disabled': {
    ...borderColor('disabled', theme.theme),
    ...color('disabled', theme.theme),
  }
})

const inputBaseStyle = theme => ({
  width: '100%',
  padding: '10px 18px',
  transitionDuration: '100ms',
  ...inputReset(theme)
})

const formStyles = createUseStyles(theme => ({
  block: {
    position: 'relative',
    marginBottom: 16
  },
  label: {
    display: 'block',
    marginBottom: 4,
    ...textSize(12, 14),
    ...color('textSecondary')
  },
  dynamicLabel: {
    position: 'absolute',
    zIndex: 5,
    ...textSize(14, 19),
    backgroundColor: 'transparent',
    padding: '0 4px',
    top: 12,
    left: 14,
    pointerEvents: 'none',
    transformOrigin: 'top left',
    transitionDuration: '100ms',
    ...color('textSecondary', theme.theme),
  },
  dynamicLabelActive: {
    color: theme.main_color,
  },
  dynamicLabelOnTop: {
    left: 14,
    transform: 'translate(0, -19px) scale(0.85)',
    ...backgroundColor('mainBackground', theme.theme),
  },
  textInput: {
    extend: inputBaseStyle(theme),
    '&:focus, &$focusedInput': {
      borderColor: theme.main_color
    }
  },
  creditCardInput: {
    width: 240,
    backgroundImage: `url(${creditCardSvg})`,
    backgroundPosition: '203px center',
    backgroundSize: '20px auto',
  },
  focusedInput: {},
  telInputBlock: {
    width: '100%',
  },
  selectInput: {
    extend: inputBaseStyle(theme),
    paddingRight: 30,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    backgroundImage: `url(${selectArrowSvg})`,
    backgroundPosition: 'center right',
    backgroundSize: '23px 6px',
    '&:focus, &$focusedInput': {
      borderColor: theme.main_color
    }
  },
  checkboxText: {
    position: 'relative',
    display: 'block',
    padding: '0 0 0 24px',
    ...textSize(14, 18),
    cursor: 'pointer',
    ...color('textSecondary', theme.theme),

    '& $checkboxInput': {
      position: 'absolute',
      left: 0,
      top: 1,
    },

    '& a': {
      ...color('textDefault', theme.theme),

      '&:hover': {
        textDecoration: 'underline',
      }
    }
  },
  checkboxInput: {
    ...inputReset(theme),
    width: 14,
    height: 14,
    borderRadius: 2,
    cursor: 'pointer',
    '&:checked': {
      backgroundImage: `url(${checkboxSvg})`,
      backgroundSize: '14px',
      backgroundPosition: 'center',
      backgroundColor: theme.main_color,
      borderColor: theme.main_color,
    },
    '&:disabled': {
      opacity: .5,
    }
  },
  datePickerInput: {
    ...inputReset(theme),
    extend: inputBaseStyle(theme),
    width: 'auto',
    flexGrow: 1
  },
  inputSuffix: {
    position: 'absolute',
    right: 19,
    paddingRight: 2,
    ...textSize(14, 41),
    ...regularFont(),
    ...color('textSecondary', theme.theme),
  },
  inputPrefix: {
    position: 'absolute',
    left: 19,
    paddingRight: 2,
    ...textSize(14, 41),
    ...regularFont(),
    ...color('textSecondary', theme.theme),
  },
  inputWithError: {
    ...borderColor('textError', theme.theme)
  },
  error: {
    display: 'block',
    padding: '4px 0',
    textAlign: 'right',
    ...textSize(12, 14),
    ...color('textError', theme.theme)
  },
  errorLeft: {
    textAlign: 'left',
  },
  errorCheckbox: {
    textIndent: 24,
  },
  globalError: {
    minHeight: 48,
    padding: '8px 15px',
    marginBottom: 16,
    borderRadius: 2,
    ...backgroundColor('errorBackground', theme.theme),
    ...color('textError', theme.theme),
    ...textSize(13, 26),
    display: 'flex',
    alignItems: 'center'
  },
  globalErrorIcon: {
    fontSize: 18,
    paddingRight: 10
  },
  hint: {
    position: 'relative',
    paddingLeft: 16,
    marginTop: 10,
    ...textSize(12, 14)
  },
  hintSecondary: {
    ...color('textSecondary', theme.theme),
  },
  hintIcon: {
    position: 'absolute',
    left: 0,
    top: 0,
    fontSize: 12
  },
  buttonsBlock: {
    paddingTop: 5,
    textAlign: 'right',
    '& > *': {
      marginLeft: 14
    }
  },
  loader: {
    display: 'inline-block'
  }
}))

export default formStyles
